<template>
  <div class="crm-card-body" style="margin-bottom: 10px" v-if="['transport', 'shuttle'].indexOf((apply || {zzInType: ''}).zzInType) !== -1">
    <van-field
        :label="(apply || {zzInType: ''}).zzInType === 'shuttle'? '班车日期': '转运日期'"
        v-model="(apply || {zzPlanInDate: ''}).zzPlanInDate"
        disabled="disabled"
    />
    <CRMSelect
        v-if="(apply || {zzInType: ''}).zzInType === 'transport'"
        @change="(value) => {changeTransferTime(value)}"
        v-model="state.transferOrder.transferTime"
        label="转运时间"
        placeholder="转运时间"
        :columns="state.transport_time_list"
        :attr="{ required: true }"
        :rules="[{ required: true, message: '请选择转运时间' }]"
        :readonly="['check', 'edit'].indexOf(type) !== -1"
    />
    <CRMSelect
        v-if="(apply || {zzInType: ''}).zzInType === 'shuttle'"
        @change="(value) => {changeShuttlePeriod(value)}"
        v-model="state.transferOrder.shuttlePeriod"
        label="班车时间"
        placeholder="班车时间"
        :columns="state.shuttle_period_list"
        :attr="{ required: true }"
        :rules="[{ required: true, message: '请选择班车时间' }]"
        :readonly="['check', 'edit'].indexOf(type) !== -1"
    />
    <van-field label="出发地" v-model="(apply || {zzHospital: ''}).zzHospital" disabled="disabled" />
    <van-field
        v-if="(apply || {zzInType: ''}).zzInType === 'transport'"
        @input="(value) => {changeLocationFloor(value)}"
        label="出发地详情"
        placeholder="楼栋-楼层-病床"
        v-model="state.transferOrder.locationFloor"
        v-bind="{ required: true }"
        :rules="[{ required: true, message: '请填写出发地详情' }]"
        :readonly="['check', 'edit'].indexOf(type) !== -1"
    />
    <van-field label="目的地" placeholder="院区-病区" v-model="state.destination_details" disabled="disabled" />
    <CRMSelect
        @change="(value) => {changeBodyPosition(value)}"
        v-model="state.transferOrder.bodyPosition"
        label="舒适体位"
        placeholder="请输入舒适体位"
        :columns="[{text: '坐', value: 1}, {text: '躺', value: 2}]"
        :attr="{ required: true }"
        :rules="[{ required: true, message: '请输入舒适体位' }]"
        :readonly="['check', 'edit'].indexOf(type) !== -1"
    />
    <van-field label="联系人电话"
               @input="(value) => {changeContactPhone(value)}"
               v-model="state.transferOrder.contactPhone"
               v-bind="{ required: true }"
               :rules="[{ required: true, message: '请选择联系人电话' }]"
               :readonly="['check', 'edit'].indexOf(type) !== -1"
    />
    <CRMSelect
        @change="(value) => {changePassengerCount(value)}"
        v-model="state.transferOrder.passengerCount"
        label="乘车人数"
        placeholder="乘车人数"
        :columns="[{text: '1', value: 1}, {text: '2', value: 2}]"
        :attr="{ required: true }"
        :rules="[{ required: true, message: '请选择乘车人数' }]"
        :readonly="['check', 'edit'].indexOf(type) !== -1"
    />
  </div>
</template>

<script>
import moment from "moment";
import CRMSelect from "@/components/CRM/Select";
import TYPES from "@/constant/types.js";
import api from "@/request/api";
import Vue from "vue";

export default {
  components: {
    CRMSelect
  },
  props: {
    apply: {
      type: Object,
      default: {},
    },
    type: {
      type: String,
      default: "add"
    }
  },
  data() {
    return {
      state: {
        transferOrder: {
          patientId: '',
          shuttlePeriod: '',
          hospital: '',
          locationFloor: '',
          bedNumber: '',
          contactPhone: '',
          passengerCount: '1',
          transferTime: '',
          otherTransferTime: '',
          departureLocation: '',
          type: 'self',
          zzHospital: '',
          bodyPosition: 1
        },
        shuttle_period_list: [
          {value: 'am', text: '上午'},
          {value: 'pm', text: '下午'},
        ],
        transport_time_list: [],
        destination_details: ''
      }
    }
  },
  computed: {
    watchTypePatientId () {
      return this.apply.patientId + '-' + this.type
    },
    watchNsWardZzBedReq () {
      return this.apply.zzPlanInArea + '-' + this.apply.nsWard
    }
  },
  watch: {
    'apply.zzInType'(newVal, oldVal) {
      const { changeTransferOrder, state } = this
      state.transferOrder.type = newVal
      changeTransferOrder()
    },
    watchTypePatientId(newVal, oldVal) {
      const rows = newVal.split('-')
      console.log(newVal, '++++++++++++++++++++++++++')
      if (rows[0]) {
        const { loadData } = this
        loadData(rows[0])
      }
    },
    watchNsWardZzBedReq(newVal, oldVal) {
      const { changeDestinationDetails } = this
      changeDestinationDetails(newVal)
    }
  },
  created() {
    const { handlerTransportTimeList, loadData } = this

    handlerTransportTimeList()
  },
  methods: {
    async loadData(patientId) {
      const { code, result } = await api.transferOrderByPatientId({patientId: patientId})
      if(code === 200 && result) {
        this.state.transferOrder = result
      }
    },
    changePassengerCount(value) {
      this.state.transferOrder.passengerCount = value
      this.changeTransferOrder()
    },
    changeBodyPosition(value) {
      this.state.transferOrder.bodyPosition = value
      this.changeTransferOrder()
    },
    changeContactPhone(value) {
      this.state.transferOrder.contactPhone = value
      this.changeTransferOrder()
    },
    changeShuttlePeriod(value) {
      this.state.transferOrder.shuttlePeriod = value
      this.changeTransferOrder()
    },
    changeTransferTime(value) {
      this.state.transferOrder.transferTime = value
      this.changeTransferOrder()
    },
    changeLocationFloor(value) {
      this.state.transferOrder.locationFloor = value
      this.changeTransferOrder()
    },
    changeTransferOrder() {
      const { state, apply } = this
      state.transferOrder.patientId = apply.patientId
      state.transferOrder.zzHospital = apply.zzHospital
      state.transferOrder.destination = state.destination_details
      this.$emit('changeTransferOrder', state.transferOrder)
    },
    changeDestinationDetails(value) {
      const { state } = this
      const hospital_area_list = (Vue.ls.get(TYPES.UI_CACHE_DB_DICT_DATA) || { crm_hospital_area: [] }).crm_hospital_area

      const rows = value.split('-')
      if (rows.filter(row => row === 'null').length > 0) {
        state.destination_details = ''
      } else {
        const hospital_area = hospital_area_list.find(item => item.value === rows[0])
        state.destination_details = [(hospital_area || {title: ''}).title, rows[1]].join('-')
      }
    },
    handlerTransportTimeList () {
      const { state } = this
      state.transport_time_list = []
      for (let i = 8; i < 16; i++) {
        const item = {text: `${moment().hour(i).minute(0).format('HH:mm')}`, value: `${moment().hour(i).minute(0).format('HH:mm')}`}
        state.transport_time_list.push(item)
      }
      state.transport_time_list.push({text: '其他', value: 'other'})
    },
  }
}
</script>

<style scoped lang="less">

</style>
